import extend from '~/utils/extend-vue-app';
import { v4 as uuidv4 } from 'uuid';

export default function ({ app }) {
    extend(app, {
        data() {
            return {
                sessionRemoved: false,
                isFetchingUserData: false
            };
        },
        methods: {
            getSession: () => app.$cookies.get('token'),
            setSession: async function (session) {
                if (!session || session === app.$axios.defaults.headers.common['Authorization']) {
                    return;
                }
                app.$axios.setHeader('Authorization', `Bearer ${session}`);

                if (this.isFetchingUserData) return;

                this.isFetchingUserData = true;

                try {
                    // await app.store.dispatch('auth/fetchUserData');
                    await app.store.dispatch('auth/setIsAuth', true);
                    // await app.store.dispatch('orders/fetchOrderHistory');
                    if (app.store.getters['global/getIsFarmacie'] && session) {
                        await app.store.dispatch('farmacieCart/fetchAllCartData');
                        // await app.store.dispatch('auth/fetchUserData');
                    }
                } catch (error) {
                    console.error('Error setting session:', error);
                } finally {
                    this.isFetchingUserData = false;
                }
            },
            removeSession: async function () {
                if (this.sessionRemoved) return;

                this.sessionRemoved = true;

                app.$cookies.remove('token');
                app.$cookies.remove('refresh_token');
                app.$axios.setHeader('Authorization', null);

                if (typeof window !== 'undefined' && !app.$cookies.get('token')) {
                    app.$cookies.remove('token');
                    app.$cookies.remove('refresh_token');
                }
            },
            checkBrowserId: async function () {
                if (process.client && typeof localStorage !== 'undefined') {
                    let browserId = localStorage?.getItem('browser_id');
                    if (!browserId) {
                        browserId = uuidv4();
                        localStorage.setItem('browser_id', browserId);
                    }

                    if (!app.store.getters['auth/isAuth'] && app.store.getters['global/getIsFarmacie']) {
                        await app.store.dispatch('farmacieCart/fetchAllCartData');
                    }
                    return browserId;
                }
                return null;
            },
            refreshToken: async function () {
                const refreshToken = app.$cookies.get('refresh_token');

                if (refreshToken) {
                    try {
                        const { access } = await app.$axios.$post('/auth/jwt/refresh/', { refresh: refreshToken });
                        const expiresDate = new Date();
                        expiresDate.setDate(expiresDate.getDate() + 2); // 2 дня

                        app.$cookies.set('token', access, {
                            path: '/',
                            maxAge: 2 * 24 * 60 * 60,
                            expires: expiresDate,
                            sameSite: 'None',
                            secure: true
                        });
                        app.$cookies.set('refresh_token', refreshToken, {
                            path: '/',
                            maxAge: 2 * 24 * 60 * 60,
                            expires: expiresDate,
                            sameSite: 'None',
                            secure: true
                        });
                        await this.setSession(access);
                        return true;
                    } catch (error) {
                        await this.removeSession();
                        return false;
                    }
                }
                await this.removeSession();
                return false;
            },
            checkToken: async function () {
                const session = this.getSession();
                try {
                    if (session) {
                        await this.refreshToken();

                        // await this.setSession(session);
                    } else {
                        await this.refreshToken();
                    }
                } catch (error) {
                    await this.removeSession();
                }
            }
        },
        created: async function () {
            if (process.client && typeof localStorage !== 'undefined') {
                await this.checkToken();
                await this.checkBrowserId();
            }
        }
    });
}
